export type Player = {
  uid: string;
  seat_no: number;
  position: number;
  hole_cards: null;
  stack: number;
  win_amount: number;
  rake_amount: number;
  platform: "pkw";
};

export type BotApiRequest = {
  // 'request_id': f'{uuid.uuid4()}-{str(id(state))}-{self.request_id}',
  request_id: string;
  subsystem: null;
  hand: {
    gameuuid: string;
    game_type: "No-Limit Hold'em";
    game_type_code: "nlhe";
    game_mode_code: "normal";
    date: string;
    roomid: string;
    flop_pot: null;
    turn_pot: null;
    river_pot: null;
    final_pot: null;
    post_seats: unknown[];

    big_blind: number;
    ante: number;
    dealer_seat: number;
    sb_seat: number;
    bb_seat: number;
    straddle_seat: number;

    players: Player[];
    actions: {
      entries: unknown[];
      pot_sizings: false;
      big_blind_size: number;
      big_blind_sizings: false;
      street: null;
    };
  };
};

export type HandUpdateMessage = {
  message: "update";
  actor_index: number;
  board_cards: string[];
  hole_cards: [string, string][] | [][];
  stacks: number[];
  bets: number[];
  pots: number[];
  min_raise: number;
};

export type HandStartMessage = {
  message: "init";
  player_index: number;
  players: (string | null)[];
  starting_stacks: number[];
  blinds: [number, number];
};

export type ServerMessage = HandStartMessage | HandUpdateMessage;

export type GroupName = string;
export type Combination = string;
export type Action = string;
export type ActionData = Record<
  Action,
  { strategy: number; ev: number; action: string; amount?: number | null }
>;
export type Group = Record<Combination, ActionData>;
export type Groups = Record<GroupName, Group>;

export type Cell = {
  name: string;
  actions: Record<string, number>;
};

export type StrategyData = {
  matrix: Cell[][];
  actionNames: string[];
  groups: Groups;
};

export enum SuggestedActionQuality {
  Best = "best",
  Correct = "correct",
  Inaccuracy = "inaccuracy",
  Wrong = "wrong",
  Blunder = "blunder",
}

export type PlayerLog = {
  moveId: string;
  actionName: string;
  actionNameRaw: string;
  ev: number;
  strategy: number;
  amount?: number | null;
  quality: SuggestedActionQuality | null;
  sessionId: string;
};

/*
self.data = {
  'hand': {
      'gameuuid': f'{uuid.uuid4()}-{str(id(state))}',
      'game_type': 'No-Limit Hold\'em',
      'game_type_code': 'nlhe',
      'game_mode_code': 'normal',
      'actions': {
          'entries': [],
          'pot_sizings': False,
          'big_blind_size': state.blinds_or_straddles[1],
          'big_blind_sizings': False,
          'street': None,
      },
      
    
  },
  'subsystem': None,
}*/

export type RoundItem = {
  kind: "round";
  round: "flop" | "turn" | "river";
  cards: string;
};

export type ActionItem = {
  kind: "action";
  action: "fold" | "call" | "check" | "bet" | "raise";
  amount?: number;
  role: string;
};

export type ShortHistoryItem = RoundItem | ActionItem;
